import React, { useContext, useState } from "react";
import AdvisorNavbar from "../layout/AdvisorNavbar";
import LocContext from "../context/locContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FiUser, FiFileText, FiCreditCard, FiShield, FiDownload, FiMessageSquare, FiPlus, FiCheckCircle, FiAlertCircle, FiClock } from "react-icons/fi";
import Swal from "sweetalert2";
import { NavLink } from "react-router-dom";
export default function ClientProfile() {
  const { userData } = useContext(LocContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("id") || "1";

  const [activeTab, setActiveTab] = useState("overview");

  // Static data - replace with API calls later
  const [clientData] = useState({
    id: 1,
    name: "Rajesh Kumar",
    email: "rajesh@example.com",
    phone: "+91 98765 43210",
    pan: "ABCDE1234F",
    dob: "1990-05-15",
    address: "123, Main Street, Mumbai, Maharashtra - 400001",
    kycStatus: "Pending",
    bankStatus: "Verified",
    mandateStatus: "Active",
    totalInvestments: "₹2,50,000",
    activeSIPs: 3,
    lastLogin: "2 days ago",
  });

  const [kycDocuments] = useState([
    { id: 1, name: "PAN Card", status: "Verified", uploadedDate: "2024-01-10" },
    { id: 2, name: "Aadhaar Card", status: "Pending", uploadedDate: "2024-01-12" },
    { id: 3, name: "Bank Statement", status: "Verified", uploadedDate: "2024-01-08" },
  ]);

  const [bankAccounts] = useState([
    { id: 1, bankName: "HDFC Bank", accountNumber: "****1234", ifsc: "HDFC0001234", status: "Verified", isPrimary: true },
    { id: 2, bankName: "ICICI Bank", accountNumber: "****5678", ifsc: "ICIC0005678", status: "Pending", isPrimary: false },
  ]);

  const handleRequestDocument = (docName) => {
    Swal.fire({
      icon: "success",
      title: "Document Request Sent",
      text: `Request for ${docName} has been sent to the client.`,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };

  const handleRaiseTicket = () => {
    navigate("/agent/support/client-tickets?action=create&clientId=" + clientId);
  };

  const handleCreateDraft = () => {
    navigate(`/agent/mutual-funds/draft-orders?clientId=${clientId}`);
  };

  return (
    <>
    <AdvisorNavbar />
    <div className="page-content" style={{ background: "#f1f5f9" }}>

          {/* Header */}
          <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px" }}>
            <div style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
              padding: "20px",
              borderRadius: "12px",
              borderBottom: "3px solid #39b2b4",
            }}>
              <div className="d-flex justify-content-between align-items-start flex-wrap">
                <div className="d-flex align-items-center">
           
                  <div>
                    <h2 className="mb-1" >
                      {clientData.name}
                    </h2>
                    <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/agent/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Client Profile
                  </li>
                </ol>
              </nav>
                  </div>
                </div>
                <div className="d-flex gap-2 flex-wrap mt-3 mt-md-0">
                  <button
                    className="btn"
                    onClick={handleRaiseTicket}
                    style={{
                      background: "linear-gradient(135deg, #ccf1f7 0%, #b3eaf4 100%)",
                      color: "#1bafb4",
                      border: "none",
                      borderRadius: "8px",
                      padding: "10px 20px",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <FiMessageSquare style={{ fontSize: "18px" }} />
                    Raise Ticket
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleCreateDraft}
                    style={{
                      color: "#ffffff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "10px 20px",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <FiPlus style={{ fontSize: "18px" }} />
                    Create Draft Order
                  </button>
                </div>
          
              </div>
            </div>
          </div>

          {/* Status Cards */}
          <div className="row g-3 mb-4">
            <div className="col-12 col-md-4">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
                <div className="card-body p-4" style={{
                  background: clientData.kycStatus === "Verified" 
                    ? "linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)"
                    : "linear-gradient(135deg, #ffffff 0%, #fff7ed 100%)",
                  borderLeft: `4px solid ${clientData.kycStatus === "Verified" ? "#10b981" : "#f59e0b"}`,
                }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>KYC Status</p>
                      <h5 className="mb-0" style={{
                        color: clientData.kycStatus === "Verified" ? "#10b981" : "#f59e0b",
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}>
                        {clientData.kycStatus}
                      </h5>
                    </div>
                    {clientData.kycStatus === "Verified" ? (
                      <FiCheckCircle style={{ fontSize: "28px", color: "#10b981" }} />
                    ) : (
                      <FiAlertCircle style={{ fontSize: "28px", color: "#f59e0b" }} />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)",
                  borderLeft: "4px solid #10b981",
                }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Bank Status</p>
                      <h5 className="mb-0" style={{ color: "#10b981", fontSize: "20px", fontWeight: "bold" }}>
                        {clientData.bankStatus}
                      </h5>
                    </div>
                    <FiCreditCard style={{ fontSize: "28px", color: "#10b981" }} />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)",
                  borderLeft: "4px solid #10b981",
                }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Mandate Status</p>
                      <h5 className="mb-0" style={{ color: "#10b981", fontSize: "20px", fontWeight: "bold" }}>
                        {clientData.mandateStatus}
                      </h5>
                    </div>
                    <FiShield style={{ fontSize: "28px", color: "#10b981" }} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="card shadow-sm mb-4" style={{ borderRadius: "12px", border: "none" }}>
            <div className="card-body p-0">
              <ul className="nav nav-tabs d-flex" style={{ borderBottom: "2px solid #e2e8f0", padding: "0 20px" }}>
                {[
                  { id: "overview", label: "Overview" },
                  { id: "kyc", label: "KYC Documents" },
                  { id: "bank", label: "Bank Accounts" },
                ].map((tab) => (
                  <li className="nav-item" key={tab.id}>
                    <button
                      className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                      onClick={() => setActiveTab(tab.id)}
                      style={{
                        border: "none",
                        borderBottom: activeTab === tab.id ? "3px solid #1bafb4" : "3px solid transparent",
                        color: activeTab === tab.id ? "#1bafb4" : "#64748b",
                        fontWeight: activeTab === tab.id ? "600" : "500",
                        padding: "16px 20px",
                        background: "transparent",
                        borderRadius: "0",
                      }}
                    >
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>

              <div className="p-4">
                {activeTab === "overview" && (
                  <div>
                    <h4 className="mb-4" style={{ color: "#1bafb4", fontSize: "20px", fontWeight: "bold" }}>
                      Profile Information
                    </h4>
                    <div className="row g-4">
                      <div className="col-12 col-md-6">
                        <div className="mb-3">
                          <label style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Full Name</label>
                          <p style={{ color: "#1e293b", fontSize: "16px", margin: "4px 0 0 0" }}>{clientData.name}</p>
                        </div>
                        <div className="mb-3">
                          <label style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Email Address</label>
                          <p style={{ color: "#1e293b", fontSize: "16px", margin: "4px 0 0 0" }}>{clientData.email}</p>
                        </div>
                        <div className="mb-3">
                          <label style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Phone Number</label>
                          <p style={{ color: "#1e293b", fontSize: "16px", margin: "4px 0 0 0" }}>{clientData.phone}</p>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="mb-3">
                          <label style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>PAN Number</label>
                          <p style={{ color: "#1e293b", fontSize: "16px", margin: "4px 0 0 0" }}>{clientData.pan}</p>
                        </div>
                        <div className="mb-3">
                          <label style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Date of Birth</label>
                          <p style={{ color: "#1e293b", fontSize: "16px", margin: "4px 0 0 0" }}>
                            {new Date(clientData.dob).toLocaleDateString()}
                          </p>
                        </div>
                        <div className="mb-3">
                          <label style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Address</label>
                          <p style={{ color: "#1e293b", fontSize: "16px", margin: "4px 0 0 0" }}>{clientData.address}</p>
                        </div>
                      </div>
                    </div>
                    <div className="row g-3 mt-2">
                      <div className="col-12 col-md-4">
                        <div className="card" style={{ background: "#f8fafc", borderRadius: "8px", padding: "16px" }}>
                          <p className="mb-1" style={{ color: "#64748b", fontSize: "12px" }}>Total Investments</p>
                          <h5 className="mb-0" style={{ color: "#1bafb4", fontSize: "20px", fontWeight: "bold" }}>
                            {clientData.totalInvestments}
                          </h5>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className="card" style={{ background: "#f8fafc", borderRadius: "8px", padding: "16px" }}>
                          <p className="mb-1" style={{ color: "#64748b", fontSize: "12px" }}>Active SIPs</p>
                          <h5 className="mb-0" style={{ color: "#1bafb4", fontSize: "20px", fontWeight: "bold" }}>
                            {clientData.activeSIPs}
                          </h5>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className="card" style={{ background: "#f8fafc", borderRadius: "8px", padding: "16px" }}>
                          <p className="mb-1" style={{ color: "#64748b", fontSize: "12px" }}>Last Login</p>
                          <h5 className="mb-0" style={{ color: "#1bafb4", fontSize: "20px", fontWeight: "bold" }}>
                            {clientData.lastLogin}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "kyc" && (
                  <div>
                    <h4 className="mb-4" style={{ color: "#1bafb4", fontSize: "20px", fontWeight: "bold" }}>
                      KYC Documents
                    </h4>
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr style={{ background: "#f8fafc" }}>
                            <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Document Name</th>
                            <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Status</th>
                            <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Uploaded Date</th>
                            <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {kycDocuments.map((doc) => (
                            <tr key={doc.id} style={{ borderBottom: "1px solid #e2e8f0" }}>
                              <td style={{ padding: "12px", color: "#1e293b", fontWeight: "500" }}>
                                <div className="d-flex align-items-center">
                                  <FiFileText style={{ fontSize: "20px", color: "#1bafb4", marginRight: "8px" }} />
                                  {doc.name}
                                </div>
                              </td>
                              <td style={{ padding: "12px" }}>
                                <span className="badge" style={{
                                  background: doc.status === "Verified" ? "#d1fae5" : "#fef3c7",
                                  color: doc.status === "Verified" ? "#10b981" : "#f59e0b",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}>
                                  {doc.status}
                                </span>
                              </td>
                              <td style={{ padding: "12px", color: "#64748b", fontSize: "14px" }}>
                                {new Date(doc.uploadedDate).toLocaleDateString()}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {doc.status === "Pending" ? (
                                  <button
                                    className="btn btn-sm"
                                    onClick={() => handleRequestDocument(doc.name)}
                                    style={{
                                      background: "linear-gradient(135deg, #ccf1f7 0%, #b3eaf4 100%)",
                                      color: "#1bafb4",
                                      border: "none",
                                      borderRadius: "6px",
                                      padding: "6px 12px",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Request
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-sm"
                                    style={{
                                      background: "transparent",
                                      color: "#1bafb4",
                                      border: "1px solid #b3eaf4",
                                      borderRadius: "6px",
                                      padding: "6px 12px",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    <FiDownload style={{ fontSize: "14px" }} />
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {activeTab === "bank" && (
                  <div>
                    <h4 className="mb-4" style={{ color: "#1bafb4", fontSize: "20px", fontWeight: "bold" }}>
                      Bank Accounts
                    </h4>
                    <div className="row g-3">
                      {bankAccounts.map((account) => (
                        <div key={account.id} className="col-12 col-md-6">
                          <div className="card" style={{
                            borderRadius: "12px",
                            border: account.isPrimary ? "2px solid #39b2b4" : "1px solid #e2e8f0",
                            background: account.isPrimary ? "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)" : "#ffffff",
                          }}>
                            <div className="card-body p-4">
                              <div className="d-flex justify-content-between align-items-start mb-3">
                                <div>
                                  <h6 className="mb-1" style={{ color: "#1e293b", fontSize: "16px", fontWeight: "600" }}>
                                    {account.bankName}
                                  </h6>
                                  {account.isPrimary && (
                                    <span className="badge" style={{
                                      background: "#ccf1f7",
                                      color: "#1bafb4",
                                      padding: "4px 8px",
                                      borderRadius: "4px",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                    }}>
                                      Primary
                                    </span>
                                  )}
                                </div>
                                <span className="badge" style={{
                                  background: account.status === "Verified" ? "#d1fae5" : "#fef3c7",
                                  color: account.status === "Verified" ? "#10b981" : "#f59e0b",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}>
                                  {account.status}
                                </span>
                              </div>
                              <div>
                                <p className="mb-1" style={{ color: "#64748b", fontSize: "13px" }}>
                                  Account: {account.accountNumber}
                                </p>
                                <p className="mb-0" style={{ color: "#64748b", fontSize: "13px" }}>
                                  IFSC: {account.ifsc}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
    </>
  );
}
